import React from 'react';
import WorkspaceLayout from '../components/WorkspaceLayout';
import WorkspacePortfolioManager from '../components/workspace/WorkspacePortfolioManager';

function PortfolioWorkspacePage() {
  return (
    <WorkspaceLayout
      active="/Portfolio"
      title="Portfolio"
      description="작업 결과물을 직무별 포트폴리오로 정리합니다. 기존 이미지 업로드, 프로젝트 설명, 공개 관리 흐름은 유지하고 화면 진입과 분류 구조를 새로 정리했습니다."
      statusTitle="포트폴리오 구성"
      metrics={[
        { label: '직무 분류', value: '5개' },
        { label: '이미지 업로드', value: '지원' },
        { label: '공개 관리', value: '지원' },
      ]}
      toolbarTitle="직무별 포트폴리오"
      toolbarText="프로젝트 성격에 맞는 분류를 선택하고 이미지와 작업 내용을 등록합니다."
      badge="업로드 지원"
    >
      <WorkspacePortfolioManager />
    </WorkspaceLayout>
  );
}

export default PortfolioWorkspacePage;
